module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-quote-85ff43ef.svg";